/**
 * The mirrored-icon helper (docs/contributing/i18n.md, "Right-to-left"): wrap an icon whose direction means
 * something (an arrow "back", a chevron "next", "open the side panel") so it points the other way in Arabic and
 * Hebrew. Never wrap logos, brand marks, charts, maps or anything drawn on a canvas.
 *
 *   <DirIcon><ChevronRight size={16} /></DirIcon>
 */
import type { ReactNode } from "react";

export function DirIcon({ children }: { children: ReactNode }) {
  return <span className="i18n-mirror" style={{ display: "inline-flex" }}>{children}</span>;
}

/** lucide icons that point somewhere: these need <DirIcon> (the i18n spec lists their unwrapped uses). */
export const DIRECTIONAL_ICONS = [
  "ArrowLeft", "ArrowRight", "ChevronLeft", "ChevronRight", "ChevronsLeft", "ChevronsRight", "ArrowLeftRight",
  "CornerDownLeft", "CornerDownRight", "Undo", "Undo2", "Redo", "Redo2", "LogOut", "LogIn", "PanelLeft", "PanelRight",
  "ExternalLink", "Reply", "Forward", "SkipBack", "SkipForward",
] as const;
